<template>
    <add-channel @closeFn="close" v-model="form" :config="config"></add-channel>    
</template>
<script>
import addChannel from '@/components/addChannel.vue'
export default {
    components: {
        addChannel
    },
    props:{
        value:Object
    },
    data(){
        return{
            form:{},
            config:{
                title:'新增渠道',
                list:[
                    {type:'input',label:'渠道',prop:'channel',req:true,req_tip:'请输入渠道'},
                    {type:'input',label:'渠道名',prop:'channel_name',req:true,req_tip:'请输入渠道名称'},
                ],
                btnFn:this.pushFn
            },
            ajax:false,
        }
    },
    created(){

        if(this.value.id){
            this.config.title = '编辑渠道';
            this.form = this.value;
            this.config.list[0].disabled = true;
        }
    },
    methods:{
        close(n){
            this.$emit('closeFn',n || '')
        },
        pushFn(){
            if(this.ajax){
                this.$message('正在处理请稍后')
                return
            }
            let url = 'quickerAddcChannel';
            if(this.form.id){
                url = 'quickerEditChannel'
            }
            this.ajax = true;
            this.api[url](this.form).then(da=>{
                this.ajax = false;
                if(da=='error'){return}
                this.$message('操作成功')
                this.close('sx')
            }).catch(()=>{
                this.ajax = false;
            })
        },
    }

};
</script>
<style >

</style>

